<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     单选选择器-重要
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="radios">
    <!-- 单选--重要 -->
    <el-radio-group v-if="type == 'major'" v-model="radio" @change="radioChange">
      <el-radio-button v-for="item in groups" :label="item.value" :key="item.value">{{ item.title }}</el-radio-button>
    </el-radio-group>

    <template v-if="type != 'major'">
      <!-- 单选次要 -->
      <div class="f-radios flex">
        <!-- 分离radio -->
        <div v-if="optionsl.length" class="all flex" :class="[ border && 'border']">
          <div v-for="item in optionsl" :key="item.value" role="button" :class="item.value == radio ? 'active' : ''" class="item" @click="handleClick(item)">
            <span>{{ item.title }}</span>
          </div>
        </div>
        <!-- 箭头步骤型 -->
        <div v-if="type == 'arrow'" class="steps flex" :class="[ border && 'border']">
          <div v-for="(item, i) in optionsr" :key="item.value" role="button" :style="i == optionsr.length - 1 ? 'padding-right: 15px' : 'padding-right: 40px'" :class="i == 0 ? 'pl' : 'pl-sm'" class="item" @click="handleClick(item)">
            <span :class="radio == item.value ? 'text-success' : ''">{{ item.title }}</span>
            <!-- 箭头样式 -->
            <div v-if="i !== optionsr.length - 1" class="arrow-container">
              <div class="arrow"></div>
            </div>
          </div>
        </div>
        <!-- 背景色 -->
        <div v-if="type == 'minor'" class="opts flex" :class="[ border && 'border']">
          <div v-for="item in optionsr" :key="item.value" role="button" :class="item.value == radio ? 'active' : ''" class="item" @click="handleClick(item)">
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FRadioBtnGroup",

  props: {
    value: {
      type: [Number, String],
      default: 0,
    },

    groups: {
      type: Array,
      default() {
        return []
      }
    },

    type: {
      // 选择器类型 =>  'major','arrow',minor'
      type: String,
      default: 'minor'
    },

    border: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      optionsl: [],
      optionsr: [],
    }
  },

  computed: {
    radio: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  created() {
    if (this.type != 'major' && this.groups.length) {
      this.optionsl = this.groups.filter( i => i.separate)
      this.optionsr = this.groups.filter( i => !i.separate)
    }
  },

  methods: {
    radioChange(e) {
      this.$emit('change', e)
    },

    handleClick(item) {
      this.radio = item.value
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.f-radios {
  height: 36px;
  transition: all 0.3s;
  .all {
    margin-right: 10px;
    height: 100%;
    border-radius: 3px;
    background-color: #fff;
    .item {
      padding: 0 20px;
      height: 100%;
      line-height: 36px;
      text-align: center;
      &:hover {
        color: #07c160;
      }
    }
    .active {
      color: #07c160;
      // border-radius: 3px;
      // background-color: rgba(238, 239, 244, 100);
    }
  }
  .steps {
    height: 36px;
    border-radius: 3px;
    overflow: hidden;
    .item {
      // flex: 1;
      height: 100%;
      line-height: 36px;
      position: relative;
      background-color: #fff;
      &:hover {
        color: #07c160;
      }
      .arrow-container {
        position: absolute;
        top: 0;
        right: 0px;
        height: 36px;
        width: 30px;
        overflow: hidden;
        .arrow {
          content: '';
          border: 4px solid #eeeff4;
          border-bottom: none;
          border-left: none;
          background-color: #fff;
          height: 32px;
          width: 32px;
          position: absolute;
          display: block;
          top: 3px;
          left: -15px;
          z-index: 10;
          transform: rotate(45deg);
        }
      }
    }
    &::after {
      content: '.';
      display: block;
      clear: both;
      visibility: hidden;
      font-size: 0;
      height: 0;
      line-height: 0;
    }
  }
  .opts, .f-radios {
    padding: 4px 10px;
    border-radius: 3px;
    overflow: hidden;
    background-color: #fff;
    .item {
      padding: 0 20px;
      height: 100%;
      line-height: 28px;
      text-align: center;
      &:hover {
        color: #07c160;
      }
    }
    .active {
      color: #07c160;
      border-radius: 3px;
      background-color: rgba(238, 239, 244, 100);
    }
  }
}
</style>
